// const logo = new Image().src = 'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/marriott-hotels/logo.png';
// const heroImageLarge = new Image().src = 'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/marriott-hotels/heroLarge.png';
// const heroImageSmall = new Image().src = 'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/marriott-hotels/heroSmall.png';
// const heroImageXSmall = new Image().src = 'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/marriott-hotels/heroXSmall.png';
// const exploreImageLarge = new Image().src = 'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/marriott-hotels/exploreLarge.png';
// const exploreImageSmall = new Image().src = 'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/marriott-hotels/exploreSmall.png';
// const exploreImageXSmall = new Image().src = 'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/marriott-hotels/exploreXSmall.png';
import { themePrimaryColorsBrand } from '../style-constants';
import { baseURL } from '../../config';

export default {
  extendedTheme: () => ({
    logo: (new Image().src =
      `${baseURL}/public-assets/dlz2/images/themes/marriott-hotels/logo.png`),
    heroImageLarge: (new Image().src =
      `${baseURL}/public-assets/dlz2/images/themes/marriott-hotels/heroLarge.png`),
    exploreImageLarge: (new Image().src =
      `${baseURL}/public-assets/dlz2/images/themes/marriott-hotels/exploreLarge.png`),
    palette: {
      primary: {
        main: themePrimaryColorsBrand.MHRS,
      },
      secondary: {
        main: '#1c1c1c',
      },
      primaryBtnHover: {
        main: '#85001C',
      },
      buttonText: {
        main: '#ffffff',
      },
      interaction: {
        main: '#db002e',
      },
      text: {
        primary: '#1c1c1c',
      },
      link: {
        primary: '#1c1c1c',
      },
    },
    typography: {
      useNextVariants: true,
      fontFamily: [
        '"ProximaNova-Regular"',
        '"Roboto"',
        '"Helvetica"',
        '"Arial"',
        'sans-serif',
      ].join(','),
    },
  }),
  typography: (theme, remCalc) => {
    return {
      h1: {
        fontFamily: 'EffraMedium',
        color: '#1c1c1c',
        [theme.breakpoints.up('sm')]: {
          fontSize: remCalc(54),
          lineHeight: remCalc(60),
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: remCalc(34),
          lineHeight: 1.24,
        },
      },
      h2: {
        fontFamily: 'EffraMedium',
        color: '#1c1c1c',
        [theme.breakpoints.up('sm')]: {
          fontSize: remCalc(40),
          lineHeight: 1.15,
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: remCalc(30),
          lineHeight: 1.2,
        },
      },
    };
  },
  extraTypography: (theme, remCalc) => {
    return {
      hero: {
        fontFamily: 'EffraMedium',
        color: '#1c1c1c',
        [theme.breakpoints.up('sm')]: {
          fontSize: remCalc(44),
          lineHeight: 1.09,
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: remCalc(44),
          lineHeight: 1.09,
        },
      },
      card: {
        fontFamily: 'EffraMedium',
        fontWeight: 'bold',
        color: '#1c1c1c',
        [theme.breakpoints.up('sm')]: {
          fontSize: remCalc(38),
          lineHeight: 1.16,
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: remCalc(28),
          lineHeight: 1.21,
        },
      },
    };
  },
};
